export function zoomImg() {
    // Zoom functionality disabled
}
